import { setDefaultAuthMethod } from '@m/utils/http';

// TODO: Once migrated to NextJS, make this be controlled by an env variable since we'll have app level env variables.
setDefaultAuthMethod('token');

export { default } from './PortalApp';
